import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Printer, Menu, X } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Our Work',
  target: 'work'
}, {
  label: 'Why Us',
  target: 'why-us'
}];
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  function scrollToSection(id: string) {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
    setMenuOpen(false);
  }
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b-4 border-black" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-75">
        <button onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center gap-2" aria-label="Strata Custom Apparel — back to top" data-id="element-76">
          <Printer className="w-8 h-8" strokeWidth={2.5} data-id="element-77" />
          <span className="font-display font-bold text-2xl tracking-wider uppercase hidden sm:inline" data-id="element-78">
            STRATA CUSTOM APPAREL
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-79">
          {NAV_LINKS.map(link => <button key={link.target} onClick={() => scrollToSection(link.target)} className="text-sm font-bold uppercase tracking-wider hover:text-gray-600 transition-colors" data-id="element-80">
              {link.label}
            </button>)}
        </nav>

        <div className="flex items-center gap-4" data-id="element-81">
          <a href="tel:+18582542524" className="hidden lg:flex items-center gap-2 text-sm font-bold uppercase tracking-wider hover:text-gray-600 transition-colors" data-id="element-82">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-83">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" data-id="element-84" />
            </svg>
            1-858-254-2524
          </a>

          <motion.button onClick={() => scrollToSection('quote-form')} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="hidden sm:block bg-black text-white px-6 py-2.5 font-display font-bold uppercase tracking-widest text-sm hover:bg-neutral-800 transition-colors" data-id="element-85">
            Get a Fast Quote
          </motion.button>

          {/* Mobile menu toggle */}
          <button onClick={() => setMenuOpen(v => !v)} className="md:hidden p-2 -mr-2" aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} data-id="element-86">
            {menuOpen ? <X className="w-7 h-7" strokeWidth={2.5} data-id="element-87" /> : <Menu className="w-7 h-7" strokeWidth={2.5} data-id="element-88" />}
          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      <AnimatePresence data-id="element-89">
        {menuOpen && <motion.nav initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden overflow-hidden bg-white border-t-2 border-black" data-id="element-90">
            <div className="px-4 sm:px-6 py-4 flex flex-col" data-id="element-91">
              {NAV_LINKS.map(link => <button key={link.target} onClick={() => scrollToSection(link.target)} className="text-left py-3 text-base font-bold uppercase tracking-wider border-b border-gray-200 hover:text-gray-600 transition-colors" data-id="element-92">
                  {link.label}
                </button>)}
              <a href="tel:+18582542524" className="py-3 text-base font-bold uppercase tracking-wider border-b border-gray-200 hover:text-gray-600 transition-colors" data-id="element-93">
                Call 1-858-254-2524
              </a>
              <button onClick={() => scrollToSection('quote-form')} className="mt-4 bg-black text-white py-3 font-display font-bold uppercase tracking-widest text-sm hover:bg-neutral-800 transition-colors" data-id="element-94">
                Get a Fast Quote
              </button>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}